export default __webpack_public_path__ + "static/jvc-150-fund-ca-promo-final-english-e9391da616efa1a4770c81bd3ac0e416.png";